import { createFileRoute, Link } from "@tanstack/react-router";
import { SERVICES, BUSINESS } from "@/lib/site-data";

export const Route = createFileRoute("/services")({
  head: () => ({
    meta: [
      { title: "SEO & Google Ads Services for Trades Contractors | Lehi, UT" },
      {
        name: "description",
        content:
          "Local SEO, Google Ads, Google Business Profile management, and website design for HVAC, plumbing, electrical, and home-service contractors in Utah County.",
      },
      { property: "og:title", content: "SEO & Google Ads for Trades Contractors" },
      {
        property: "og:description",
        content: "Lead-gen services built for trades contractors across Utah County.",
      },
      { property: "og:url", content: "/services" },
    ],
    links: [{ rel: "canonical", href: "https://lehitradessaeo.com/services" }],
  }),
  component: ServicesIndex,
});

function ServicesIndex() {
  return (
    <main className="mx-auto max-w-6xl px-6 py-20">
      <p className="text-xs font-medium uppercase tracking-[0.2em] text-muted-foreground">
        Services
      </p>
      <h1 className="mt-4 font-display text-5xl tracking-tight md:text-6xl">
        SEO &amp; SEM built for trades contractors.
      </h1>
      <p className="mt-5 max-w-2xl text-lg text-muted-foreground">
        {BUSINESS.name} runs local SEO, Google Ads, Google Business Profile,
        and conversion-built websites for HVAC, plumbing, electrical, roofing,
        and home-service contractors across Utah County.
      </p>
      <div className="mt-12 grid gap-6 md:grid-cols-2">
        {SERVICES.map((s) => (
          <Link
            key={s.slug}
            to="/services/$service"
            params={{ service: s.slug }}
            className="group block rounded-2xl border border-border bg-card p-8 transition hover:border-primary/40 hover:shadow-sm"
          >
            <div className="flex items-center justify-between">
              <h2 className="font-display text-2xl tracking-tight">{s.name}</h2>
              <span className="text-primary transition group-hover:translate-x-1">→</span>
            </div>
            <p className="mt-3 text-muted-foreground">{s.tagline}</p>
            <ul className="mt-5 grid grid-cols-1 gap-1.5 text-sm text-muted-foreground sm:grid-cols-2">
              {s.jobs.slice(0, 4).map((j) => (
                <li key={j} className="flex items-start gap-2">
                  <span className="mt-1.5 inline-block h-1 w-1 shrink-0 rounded-full bg-primary" />
                  {j}
                </li>
              ))}
            </ul>
          </Link>
        ))}
      </div>
    </main>
  );
}